export enum AnnouncementType {
  INFO = 'info',
  DANGER = 'danger',
  COVID19 = 'covid19',
  IDENTITY_VERIFICATION_PASSED = 'identity-verification-passed',
  UPDATE_BIRTHDATE_REQUIRED = 'update-birthdate-required',
  SOFT_LAUNCH_ANNOUNCEMENT = 'soft-launch-announcement',
}
